import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Profile } from '@models/profile/profile';
import { SoftSkillEnum } from '@models/profile/soft-skill.enum';

@Component({
  selector: 'profile-soft-skills',
  templateUrl: './soft-skills.component.html',
  styleUrls: ['./soft-skills.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SoftSkillsComponent {
  @Input() profile: Profile;

  softSkillEnum = SoftSkillEnum;

  trackByKey(_: any, skill: SoftSkillEnum): string {
    return skill;
  }
}
